import { globalStyle, keyframes, style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

const sparkleKeyframes = keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale(0) translateZ(0)',
  },
  '66.666%': {
    opacity: 1,
    transform: 'scale(1.2) translateZ(0)',
  },
  '100%': {
    opacity: 0.5,
    transform: 'scale(0) translateZ(0)',
  },
});

const sparkle2Keyframes = keyframes({
  '0%': {
    opacity: 0,
    transform: 'scale(0) translateZ(0)',
  },
  '33.333%': {
    opacity: 1,
    transform: 'scale(1.2) translateZ(0)',
  },
  '66.666%': {
    opacity: 1,
    transform: 'scale(0) translateZ(0)',
  },
  '100%': {
    opacity: 0,
    transform: 'scale(0) translateZ(0)',
  },
});

const fadeOutKeyframes = keyframes({
  '0%': {
    opacity: 1,
  },
  '100%': {
    opacity: 0,
    display: 'none',
  },
});

export const wrapper = style(
  {
    position: 'relative',
    display: 'inherit',
  },
  'wrapper',
);

export const starWrapperFade = style(
  {
    animation: `750ms ease-out 1 ${fadeOutKeyframes}`,
    animationFillMode: 'forwards',
  },
  'star-wrapper-fade',
);

export const star = style(
  {
    position: 'absolute',
    transformStyle: 'preserve-3d',
    backfaceVisibility: 'hidden',
    willChange: 'transform',
  },
  'star',
);

globalStyle(`${star} path`, {
  fill: themeVars.palette['yellow-600'],
});

export const star1 = style(
  {
    width: '13px',
    height: '13px',
    animation: `2700ms ease-in infinite ${sparkle2Keyframes}`,
    top: '-1px',
    left: '-8px',
  },
  'star-1',
);

export const star2 = style(
  {
    width: '8px',
    height: '8px',
    animation: `2000ms ease-in infinite ${sparkleKeyframes}`,
    bottom: '-2px',
    left: '-3px',
  },
  'star-2',
);

export const star3 = style(
  {
    width: '7px',
    height: '7px',
    animation: `3150ms ease-in infinite ${sparkleKeyframes}`,
    top: '2px',
    right: '-5px',
  },
  'star-3',
);

export const star4 = style(
  {
    width: '11px',
    height: '11px',
    animation: `2850ms ease-in infinite ${sparkleKeyframes}`,
    bottom: '-4px',
    right: '-4px',
  },
  'star-4',
);

export const star5 = style(
  {
    width: '11px',
    height: '11px',
    animation: `2080ms ease-in infinite ${sparkle2Keyframes}`,
    top: '-4px',
    right: '-1px',
  },
  'star-5',
);
